
(function(){
  const cv=document.getElementById("roastbg2");if(!cv||!cv.getContext)return;
  const ctx=cv.getContext("2d");
  const reduce=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches;
  // roast shades from light cinnamon to full city dark
  const SH=["#9C7444","#8A6236","#77512B","#654322","#55381C","#462E17","#3A2513","#2E1D0F"];
  const SPR=[];const SZ=64;
  SH.forEach(c=>{
    const o=document.createElement("canvas");o.width=SZ;o.height=SZ;const g=o.getContext("2d");
    g.translate(SZ/2,SZ/2);
    const rg=g.createRadialGradient(-6,-8,2,0,0,26);rg.addColorStop(0,lighten(c,.28));rg.addColorStop(.6,c);rg.addColorStop(1,darken(c,.35));
    g.fillStyle=rg;g.beginPath();g.ellipse(0,0,24,17,0,0,Math.PI*2);g.fill();
    g.strokeStyle=darken(c,.55);g.lineWidth=2.6;g.lineCap="round";
    g.beginPath();g.moveTo(-18,-1);g.bezierCurveTo(-7,-7,5,6,18,1);g.stroke();
    g.fillStyle="rgba(255,236,210,.16)";g.beginPath();g.ellipse(-7,-8,8,3.5,-.35,0,Math.PI*2);g.fill();
    SPR.push(o);
  });
  function hx(c){return[1,3,5].map(i=>parseInt(c.substr(i,2),16))}
  function lighten(c,k){return"rgb("+hx(c).map(v=>Math.round(v+(255-v)*k)).join(",")+")"}
  function darken(c,k){return"rgb("+hx(c).map(v=>Math.round(v*(1-k))).join(",")+")"}
  let W=0,H=0,beans=[],smoke=[],dpr=1;
  function size(){
    const r=cv.getBoundingClientRect();dpr=Math.min(window.devicePixelRatio||1,2);
    W=r.width;H=r.height;cv.width=Math.round(W*dpr);cv.height=Math.round(H*dpr);ctx.setTransform(dpr,0,0,dpr,0,0);
    const n=Math.round(Math.min(420,Math.max(140,W*H/1900)));
    beans=[];for(let i=0;i<n;i++)beans.push(bean());
    smoke=[];for(let i=0;i<14;i++)smoke.push(puff(true));
    const tx=cv.parentNode.querySelector(".grid>div:first-child"),bg=cv.parentNode.querySelector(".bagstage");
    const tr=tx.getBoundingClientRect(),br=bg.getBoundingClientRect();
    stacked=br.top>=tr.bottom-4;
    if(stacked){zone={y0:tr.bottom-r.top-30,y1:br.top-r.top+30}}
    else{zone={x0:br.right-r.left,x1:tr.left-r.left}}
    cx=stacked?W*.5:(zone.x1+W)/2; cy=stacked?(tr.top-r.top)+tr.height*1.1:H*1.15;
  }
  let stacked=false,zone={},cx=0,cy=0;
  // 1 over the text, fading to 0 before the bag
  function fade(x,y){
    if(stacked){const k=(zone.y1-y)/(zone.y1-zone.y0);return Math.max(0,Math.min(1,k))}
    const k=(x-zone.x0)/Math.max(40,zone.x1-zone.x0);return Math.max(0,Math.min(1,k))
  }
  // beans churn on circular paths around the drum axis, low and to the left, under the bag
  function bean(){
    const R=Math.max(W,H);
    return{rad:R*(.18+Math.random()*.62),ang:Math.random()*Math.PI*2,w:(.08+Math.random()*.1)*(Math.random()<.5?1:.8),
      rot:Math.random()*6.28,vr:(Math.random()-.5)*1.6,sc:.45+Math.random()*.75,ph:Math.random()*6.28,sp:.04+Math.random()*.05}
  }
  function puff(init){return{x:stacked?W*Math.random():(zone.x1||W*.5)+(W-(zone.x1||W*.5))*Math.random(),y:init?Math.random()*H:H+40,r:60+Math.random()*120,v:10+Math.random()*16,a:.03+Math.random()*.04,dx:(Math.random()-.5)*8}}
  function frame(t,dt){
    ctx.clearRect(0,0,W,H);
    ctx.fillStyle="#1C110A";ctx.fillRect(0,0,W,H);
    // heat from below
    const hg=ctx.createRadialGradient(cx,H*1.05,10,cx,H*1.05,Math.max(W,H)*.55);
    hg.addColorStop(0,"rgba(231,120,40,.55)");hg.addColorStop(.35,"rgba(160,70,24,.22)");hg.addColorStop(1,"rgba(0,0,0,0)");
    ctx.fillStyle=hg;ctx.fillRect(0,0,W,H);
    for(const b of beans){
      b.ang-=b.w*dt;b.rot+=b.vr*dt;
      const x=cx+Math.cos(b.ang)*b.rad,y=cy+Math.sin(b.ang)*b.rad*.78;
      if(x<-40||x>W+40||y<-40||y>H+40)continue;
      const f=fade(x,y);if(f<=0.01)continue;
      const roast=.35+.65*(.5+.5*Math.sin(t*b.sp+b.ph));
      const sp=SPR[Math.min(SH.length-1,Math.floor(roast*SH.length))];
      const s=b.sc*(W<600?.75:1),depth=.55+.45*(b.rad/Math.max(W,H));
      ctx.save();ctx.globalAlpha=f*Math.min(1,.5+depth*.55);ctx.translate(x,y);ctx.rotate(b.rot);ctx.scale(s,s);
      ctx.drawImage(sp,-SZ/2,-SZ/2);ctx.restore();
    }
    for(const p of smoke){
      p.y-=p.v*dt;p.x+=p.dx*dt;p.r+=6*dt;if(p.y<-p.r)Object.assign(p,puff(false));
      const g=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,p.r);
      g.addColorStop(0,"rgba(242,234,224,"+p.a+")");g.addColorStop(1,"rgba(242,234,224,0)");
      ctx.fillStyle=g;ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,6.283);ctx.fill();
    }
    // keep the text side readable (text sits on the right in RTL)
    ctx.fillStyle="rgba(28,17,10,.52)";ctx.fillRect(0,0,W,H);
  }
  let last=0,t=0,run=true,userPaused=false;
  function loop(ts){
    const dt=Math.min(.05,(ts-(last||ts))/1000);last=ts;t+=dt;
    frame(t,dt);if(run)requestAnimationFrame(loop);
  }
  size();
  const tg=document.getElementById("roastToggle");
  function setPaused(p){userPaused=p;if(tg){tg.setAttribute("aria-pressed",String(p));tg.textContent=p?"הפעלת האנימציה":"עצירת האנימציה"}
    if(p){run=false}else if(!reduce&&!document.hidden){run=true;last=0;requestAnimationFrame(loop)}}
  if(tg){if(reduce){tg.hidden=true}else{tg.addEventListener("click",()=>setPaused(!userPaused))}}
  if(reduce){frame(4,0)}else{requestAnimationFrame(loop)}
  let to;window.addEventListener("resize",()=>{clearTimeout(to);to=setTimeout(()=>{size();if(reduce)frame(4,0);else if(userPaused)frame(t,0)},150)});
  document.addEventListener("visibilitychange",()=>{if(reduce)return;if(document.hidden){run=false}else if(!run&&!userPaused){run=true;last=0;requestAnimationFrame(loop)}});
})();
